var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AddAgencyForm',{attrs:{"title":"Configure your agency","showPrefixField":true,"submitUrl":"/api/register/set-up-agency-atlassian","onSuccessfulSubmit":_vm.handleSuccessfulSubmit},scopedSlots:_vm._u([{key:"progress-bar",fn:function(){return [_c('CompleteSignupProgressAtlassian',{attrs:{"currentStep":1}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }